import React from 'react';
import t from '@/utils/Language/ResourceCard-translations';
import classes from './DistanceTo.module.scss';
import geometry from '@/utils/geometry';
import useLocation from '@/hooks/useLocation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { resourceHelpers } from '@/utils/helpers';

const DistanceTo = ({
  className,
  locationList,
  resource,
  showBullet = false,
  showParentheses = false,
  showIcon = false,
  showOtherLocations = false,
  showAddress = false,
  distance = null,
  text = 'N miles away',
  ...props
}) => {
  const { locationContext } = useLocation();
  const getDistanceText = () => {
    if (distance !== null) {
      return t(text, { N: distance.toFixed(1) });
    }
    const dist = geometry.distanceBetween(locationContext.location, locationList[0]);
    if (dist === null) return null;
    return t(text, { N: dist.toFixed(1) });
  };

  return (
    <>
      {(locationContext.locationKnown() || distance !== null) && (
        <div className={`${className} ${classes.distanceTo}`}>
          {showIcon && <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className={classes.locationIcon} />}
          <span className={`distance-text ${classes.distanceText}`}>
            {showBullet && <span>&nbsp;&bull;&nbsp;</span>}
            {showParentheses && <span> (</span>}
            {getDistanceText()}
            {showParentheses && <span>)</span>}
          </span>
          {showOtherLocations && locationList.length > 1 && (
            <span>
              &nbsp;&ndash;{' '}
              <a href={resourceHelpers.pathTo(resource)} className={classes.otherLocationLink}>
                {t('Other locations available')}
              </a>
            </span>
          )}
          {showAddress && locationList?.[0] && (
            <span className={classes.distanceAddress}>
              <span>&nbsp;&bull;&nbsp;</span>
              {resourceHelpers.generateAddressBlock({ location: locationList[0], layout: 'inline' })}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default DistanceTo;
